module.exports = __webpack_public_path__ + "img/popular1.b5f46a81.png";